import script from "./SensorMonitor.vue?vue&type=script&setup=true&lang=js"
export * from "./SensorMonitor.vue?vue&type=script&setup=true&lang=js"

import "./SensorMonitor.vue?vue&type=style&index=0&id=f0ed079c&scoped=true&lang=css"

import exportComponent from "/Users/Ios/Documents/project/FrontEnd/qc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0ed079c"]])

export default __exports__